<template>
  <section>
    <div class="conditioner">
      <m-img src="@/v2/mobile/assets/image/h_63.jpg"></m-img>
      <div class="video_content">
        <m-video
          autoplay
          muted
          disablepictureinpicture
          x5-playsinline
          playsinline
          webkit-playsinline="true"
          ref="video"
          src="@/v2/mobile/assets/video/v_63.mp4"
        />
        <Replay class="alive_replay" @click="replayVideo($refs.video)" />
      </div>
    </div>
    <m-img src="@/v2/mobile/assets/image/h_64_2.jpg"></m-img>
    <m-img src="@/v2/mobile/assets/image/h_65.jpg"></m-img>
  </section>
</template>

<script>
import Replay from '@/components/replay.vue'
import { replayVideo } from '@/utils'
export default {
  components: {
    Replay,
  },
  methods: {
    replayVideo,
  },
}
</script>
<style lang="less" scoped>
.conditioner {
  position: relative;
  .video_content {
    position: absolute;
    bottom: 0;
    width: 100%;
    video {
      width: 100%;
    }
    .alive_replay {
      margin-left: 7%;
      margin-top: 0.2rem;
      color: #3b82fc;
    }
  }
}
</style>
